import httpClient from '../../httpClient';

/**
 * 비밀번호 초기화 페이지 이메일 인증 APi
 * @param {string} email - user email
 * @returns {Promise}
 */
function resetPasswordEmailAuth(email) {
  return httpClient({
    url: `/auth/password/email`,
    method: 'POST',
    data: {
      email,
    },
  });
}

export default resetPasswordEmailAuth;
